import { render } from "./TabsWrapper.vue?vue&type=template&id=35543b4c&scoped=true"
import script from "./TabsWrapper.vue?vue&type=script&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&lang=js"

import "./TabsWrapper.vue?vue&type=style&index=0&id=35543b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35543b4c"]])

export default __exports__